module.exports = __webpack_public_path__ + "img/close.7865556a.png";